export default class Product {
    constructor (json) {
        this.id = 0;
        this.productName = "";
        this.roleName = "";
        this.isRoleAdmin = false;

        if (json)
            mapProductToJson(json, this);
    }

    createCopy () {
        const product = new Product();
        product.id = this.id;
        product.productId = this.productId;
        product.productName = this.productName;
        product.roleName = this.roleName;
        product.isRoleAdmin = this.isRoleAdmin;

        product.roleId = this.roleId;
        product.url = this.url;
        product.adminUrl = this.adminUrl;
        return product;
    }
}

const mapProductToJson = (json, product) => {
    product.productId = json.ProductId;
    product.productName = json.ProductName;
    product.roleName = json.RoleName;
    product.roleId = json.RoleId;
    product.url = json.Url;
    product.adminUrl = json.AdminUrl;
    product.isRoleAdmin = json.IsRoleAdmin;
};

